/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Strings } from '../../Resources/Strings/Strings';
import { CatalogTagsTranslation } from '../../common/libraries/modelViewer/Data/catalogTagsTranslation';

// Class that represents the data of this store

class TextReducerData {
  language : string = '';
  strings : Strings | undefined;
  translation : CatalogTagsTranslation[] | undefined;
}

// Initial State

const initialState : TextReducerData = {
  language: '',
  strings: undefined,
  translation: new Array<CatalogTagsTranslation>(),
};

// Store definition

export const TextsReducer = createSlice({
  name: 'TextsReducer',

  initialState,

  reducers: {
    setTexts: (state, action : PayloadAction<{
      language : string,
      strings : Strings
    }>) => {
      state.language = action.payload.language;
      state.strings = { ...action.payload.strings };
    },
    setTranslation: (state, action : PayloadAction<{
      translations : CatalogTagsTranslation[]
    }>) => {
      state.translation = action.payload.translations;
    },
  },
});
